/// <reference types="vite/client" />

import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import {
  ThemeProvider,
  createTheme,
  StyledEngineProvider,
} from "@mui/material";
import "./global.css";
import store from "./store";
import AppInitializer from "./AppInitializer";
import CustomThemeProvider from "./components/ReusableDateRangePickerUI/CustomDateUi";
import * as Sentry from "@sentry/react";
import TagManager from "react-gtm-module";

let react_env = import.meta.env.VITE_ENV;

console.log("meta.env", react_env);

// Initialize Sentry for staging and production both
if (react_env === "staging" || react_env === "production") {
  Sentry.init({
    dsn: "https://0be5db9287a78d10dda16de552c7027a@o4505628677570560.ingest.us.sentry.io/4506937359990785",
    environment: react_env,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.browserProfilingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: [
      /^https:\/\/aladdin-ui-stage\.etloptival\.com/,
      /^https:\/\/aladdin-ui\.etloptival\.com/,
    ],
    profilesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    ignoreErrors: [
      "Canceled",
      "CancellationError",
      /CancellationError/i,
      /Canceled/i,
    ],
  });
}

// Initialize Google Tag Manager
const tagManagerArgs =
  react_env === "production"
    ? {
        gtmId: "GTM-W2GTT54K",
      }
    : {
        gtmId: "GTM-PX5GKBVP",
      };

TagManager.initialize(tagManagerArgs);

// Create MUI theme
const muiTheme = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "capitalize",
        },
      },
    },
  },
});

// Render the application
ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <Provider store={store}>
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={muiTheme}>
        <CustomThemeProvider>
          <AppInitializer />
        </CustomThemeProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  </Provider>,
);
